import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import TeamWorkload from '../components/TeamWorkload';
import UserGroups from '../components/UserGroups';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Users, Activity } from 'lucide-react';

const TeamPage = () => {
  const [activeTab, setActiveTab] = useState('workload');

  return (
    <Sidebar>
      <div className="min-h-screen">
        {/* Header */}
        <header className="sticky top-0 z-20 bg-background/80 backdrop-blur-lg border-b">
          <div className="px-4 sm:px-6 py-3 sm:py-4 pl-14 lg:pl-6">
            <h1 className="font-heading text-xl sm:text-2xl font-bold">Team</h1>
            <p className="text-xs sm:text-sm text-muted-foreground">
              Monitor workloads and manage user groups
            </p>
          </div>
        </header>

        {/* Main Content */}
        <main className="p-4 sm:p-6">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4 sm:space-y-6">
            <TabsList className="grid w-full max-w-md grid-cols-2">
              <TabsTrigger value="workload" className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm" data-testid="tab-workload">
                <Activity className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden sm:inline">Workload Monitor</span>
                <span className="sm:hidden">Workload</span>
              </TabsTrigger>
              <TabsTrigger value="groups" className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm" data-testid="tab-groups">
                <Users className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden sm:inline">User Groups</span>
                <span className="sm:hidden">Groups</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="workload" className="mt-4 sm:mt-6">
              <TeamWorkload />
            </TabsContent>

            <TabsContent value="groups" className="mt-4 sm:mt-6">
              <UserGroups />
            </TabsContent>
          </Tabs>
        </main>
      </div>
    </Sidebar>
  );
};

export default TeamPage;
